export default {
    delivery: {
        product: {
            tracking: "Tracking",
            quantity: "Quantity"
        }
    }
}